export default __webpack_public_path__ + "static/media/500.423bdbe3.svg";